export function IcoPcHomeScroll() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 7L12 17L2 7" stroke="url(#paint0_linear_2764_6824)" strokeWidth="2" />
      <defs>
        <linearGradient id="paint0_linear_2764_6824" x1="12" y1="7" x2="12" y2="17" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
}
